export default {
  routeImporter: {
    loadRouteFile: 'Importați fișierul',
    acceptedImportTypes: 'Tipuri de importuri acceptate',
    dictDefaultMessage: 'Trimiteți un fișier de traseu pentru a importa sau faceți clic aici',
    dictFallbackMessage: 'Browser neacceptat',
    dictFileTooBig: 'Fișier prea mare',
    dictInvalidFileType: 'Tip de fișier invalid',
    dictCancelUpload: 'Anulați încărcarea',
    dictUploadCanceled: 'Încărcare anulată',
    failedToLoadFile: 'Nu s-a reușit încărcarea fișierului selectat. Asigurați-vă că fișierul nu este corupt și că este într-unul dintre formatele acceptate',
    dictRemoveFile: 'Eliminați fișierul',
  }
}
